import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    children: ReactNode;
    className?: string;
}

const SettingSection = ({ children, className }: Props) => (
    <h2 className={twMerge('p-2 text-base font-bold text-gray-800', className)}>
        {children}
    </h2>
);

export default SettingSection;
